import React, { useState, useEffect } from "react";
import NobleSidebar from "./NobleSidebar";

const Principal = () => { 

    const [principalData, setPrincipalData] = useState(null);
    const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPrincipalData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_PROJECT_PATH}/items/principal?fields=*.*.*`,
          // "https://cms.maitretech.com/thekatarahillsschool/items/principal?fields=*.*.*",
          { cache: "no-store" }
        );
        const data = await response.json();

        if (data?.data?.length > 0) {
          const principal = data.data[0];
          const fullImageUrl = principal.principlaphoto?.data?.full_url
            ? principal.principlaphoto.data.full_url.replace("http://", "https://")
            : "";

          setPrincipalData({
            name: principal.principalname,
            message: principal.principalmessage,
            imageUrl: fullImageUrl,
          });
        }
      } catch (error) {
        console.error("Failed to fetch principal data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPrincipalData();
  }, []);
  return (
    <>
      <div className="container-fluid p-0">
        

        <div className="container-fluid latest_card_box_ad p-5">

          <div className="ourschoolboardeft px-0 text-left">

            <div className="princd">
              <div className="photos">
                <img
                  src={principalData?.imageUrl || "./images1/princ.jpeg.webp"}
                  alt={principalData?.name || "Principal"}
                />
                <div className="phname">
                  <b>Principal</b> 
                  - {principalData?.name || "Loading..."}
                </div>
              </div>

              <div className="director_mess">
                <h5>
                  <b>Principal Message -</b>
                </h5>
                <p>
                  {principalData?.message ||
                  "Welcome message from the principal will appear here."}
                  {/* Warm Greeting from The Katara Hills school family, we firmly believed
                  that school education lays the foundation for the future of
                  the students and ensure a stable. According to the words of Swami Vivekanand "Arise, awake
                  and stop not till the goal is reached" echo in my mind. The
                  School activities are planned and prepared meticulously,
                  Our mission is to produce educated smart and confident
                  citizens of India. */}
                </p>
              </div>
            </div>
          {/* <h4 className="kalurr" style={{color:"black", fontWeight:"bold"}}>Our Principal</h4> */}
            
            <p>
              <b>Dear Parents, Students, and Visitors:</b>
            </p>
            <p>
              <i>The Katara Hills School</i>
            </p>
            <p>
              Welcome to the The Katara Hills School. As we embark into a
              new journey of growth and learning, we will
              be able to take our school to the next level. At our end, we shall
              continue working with you for the best interests of our beloved
              students and our community at large.
            </p>
             
            <p>
              Nothing can be more effective in motivating the students and
              sustaining success in the school than celebrating the students’
              accomplishments. Celebrating success in the school system
              regularly breeds more success. It invites every student, teacher,
              and parent to join the team to celebrate improvements in
              academics, character, and leadership.
            </p>
            {/* <p>
              Nothing can be more effective in motivating the students and
              sustaining success in the school than celebrating the students’
              accomplishments. Celebrating success in the school system
              regularly breeds more success. It invites every student, teacher,
              and parent to join the team to celebrate improvements in
              academics, character, and leadership.
            </p> */}
            <p>
              As the The Katara Hills School principal, I am more than
              willing to do all it takes to make our school an outstanding
              institution, where our students are nurtured through mind, body,
              and soul. Such a mission will not be possible to accomplish
              without the full support and cooperation of our parent body and
              community at large. Hence, should you have any suggestions or
              constructive feedback, do not hesitate to contact me by email or
              phone.
            </p>
            <p>We look forward to serving you and your children.</p>
            <p>
            </p>
            <p>
              <b>Mrs Priyam Khare, Principal  </b>
            </p>
            {/* <p>The Katara Hills School</p> */}
            <p>
              The Katara Hills, Bhopal, Madhya Pradesh
              466001, India
              <p>School Phone: +91 8770553362 , +91 7772888558</p>
              <p>Fax: +91 7772888558</p>
            </p>
          </div>

          <div className="ourschoolright p-4">
            <NobleSidebar />
          </div>
        </div>
      </div>
    </>
  );
};

export default Principal;
